<template>
    <div class="link-list">
        <span class="link-list__title">
            {{ $t('payment stuff') | capitalize }}
        </span>
        <ul class="link-list__items">
            <StaticLink
                v-for="(payment, i) in payments"
                :path="payment.path"
                :key="i"
                tag="a"
                class="link-list__item"
            >
                <img
                    :src="`/static/img/footer/${payment.img}`"
                    class="footer__legal-section--image mb-2 mr-4"
                    :width="`${payment.width}px`"
                    :height="`${payment.height}px`"
                >
            </StaticLink>
        </ul>
    </div>
</template>

<script>
    import config from '@config';

    export default {
        created() {
            this.payments = config.countrySpecific.footer.payments;
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/modules/layout/footer/components/PaymentLinks.vue